import React, { useEffect, useState } from 'react'
import RightModal from '../../../components/Modals/RightModal'
import InputTextarea from '../../../components/InputGroup/InputTextarea';
import InputSelect from '../../../components/InputGroup/InputSelect';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import InputText from '../../../components/InputGroup/InputText';
import MobileInput from '../../../components/InputGroup/MobileInput';
import { ReactComponent as BookingIcon } from '../../../assets/icons/booking.svg';
import CenterModal from '../../../components/Modals/center-modal';
import { getProjects } from '../../../services/private/company.service';

const RequestBooking = ({ show, closeModal }) => {

    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [project, setProjects] = useState([]);
    const [commnets, setComments] = useState('');
    const [projectList, setProjectList] = useState([])
    const [error, setError] = useState('');

    const getAllProjects = async () => {

        await getProjects({}, '').then((res) => {
            if (res.status === 200) {
                console.log(res.data.data, 'data')
                let projects = res.data.data.map(i => ({ ...i, label: i.name, value: i.uuid }));
                setProjectList(projects)
            }
        }).catch((err) => {
            console.log("Something went wrong", err);
        })
    }

    useEffect(() => {
        getAllProjects()
    }, []);

    const handleSubmit = () => {

    }

    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!w-[560px]  [&>*]:!border-0 [&>*]:!rounded-xl [&>*]:!overflow-hidden'>
            <div className='!p-6'>
                <div className={`d-flex align-items-center justify-content-between`}>
                    {/* <h2 className='fz18 black fw-po-medium mb-0 inter'>Project Added to your list</h2> */}
                    <div className='h-12 w-12 rounded-xl bg-green flex items-center justify-center'>
                        <BookingIcon className='fill-white h-6 w-6' />
                    </div>
                    <button onClick={closeModal} className='border-0 bg-tr'><CloseIcon /></button>
                </div>
                <div className='!mt-4'>
                    <h1 className='m-0 text-lg font-semibold'>Add Token Request</h1>
                </div>
                <div className='grid grid-cols-2 !gap-2'>
                    <div className='col-span-2'>
                        <InputText
                            label={'Name'}
                            placeholder={'e.g. Rahul'}
                            inputclass={'!mb-0'}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            error={error && !name ? 'Please Enter Name' : ''}
                        />
                    </div>
                    <MobileInput
                        label='Mobile'
                        value={mobile}
                        onChange={(e) => setMobile(e.phone)}
                        error={(error && !mobile) ? 'Please Enter Mobile' : ''}
                        // disable={userMobile ? true : false}
                        inputclass='!h-10 !w-full !mb-0'
                    />
                    <InputSelect
                        label={'Projects'}
                        value={project}
                        onChange={(value) => setProjects(value)}
                        error={(error && project.length === 0) ? 'Please Select Project' : ''}
                        options={projectList}
                        isMulti={true}
                    />

                    <div className='col-span-2'>
                        <InputTextarea
                            label={'Comments'}
                            inputclass={'!mb-0'}
                            value={commnets}
                            onChange={(e) => setComments(e.target.value)}
                        />
                    </div>

                </div>
                <div className='w-full flex !gap-4 !mt-4'>
                    <button className='w-1/2 border py-2 text-black700 rounded-lg'>Cancel</button>
                    <button
                        className='w-1/2 gradient-blue text-white py-2 rounded-lg font-medium'
                        onClick={handleSubmit}
                    >Submit</button>

                </div>
            </div>
        </CenterModal>
    )
}

export default RequestBooking